import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpResponse } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ng6-toastr-notifications';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { HomeComponent } from './home/home.component';
import { ProcessComponent } from './process/process.component';
import { ProjectsComponent } from './projects/projects.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { BusinesscardComponent } from './businesscard/businesscard.component';
import { ViewComponent } from './businesscard/view/view.component';
import { DnourComponent } from './dnour/dnour.component';
import { GodlyComponent } from './businesscard/godly/godly.component';
import { PakhisComponent } from './pakhis/pakhis.component';
import { BeyouComponent } from './beyou/beyou.component';
import { AutokooroshComponent } from './autokoorosh/autokoorosh.component';
import { VendettaComponent } from './vendetta/vendetta.component';
import { SpacexComponent } from './spacex/spacex.component';
import {
	NgbModule,
	NgbActiveModal,
	NgbAccordionModule,
	NgbAlertModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FaqComponentComponent } from './faq-component/faq-component.component';
import { ServicesComponent } from './services/services.component';
import { BradingComponent } from './brading/brading.component';
import { WebsiteComponent } from './website/website.component';
import { EcommerceComponent } from './ecommerce/ecommerce.component';
import { GraphicsComponent } from './graphics/graphics.component';
import { StudioComponent } from './studio/studio.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { UnsubscriptionComponent } from './unsubscription/unsubscription.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClientsComponent } from './clients/clients.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MiniaarComponent } from './miniaar/miniaar.component';
import { DetailMasterComponent } from './detail-master/detail-master.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CasestudyComponent } from './casestudy/casestudy.component';
import { DemoCaseStudyComponent } from './demo-case-study/demo-case-study.component';
import { CrystalcargoComponent } from './crystalcargo/crystalcargo.component';
import { TestimonialComponent } from './testimonial/testimonial.component';

import { LucideAngularModule, ChevronRight, Check  } from 'lucide-angular';

@NgModule({
	declarations: [
		AppComponent,
		AboutComponent,
		ContactComponent,
		HomeComponent,
		ProcessComponent,
		ProjectsComponent,
		NavbarComponent,
		FooterComponent,
		BusinesscardComponent,
		ViewComponent,
		DnourComponent,
		GodlyComponent,
		PakhisComponent,
		BeyouComponent,
		AutokooroshComponent,
		VendettaComponent,
		SpacexComponent,
		FaqComponentComponent,
		ServicesComponent,
		BradingComponent,
		WebsiteComponent,
		EcommerceComponent,
		GraphicsComponent,
		StudioComponent,
		PaymentFailedComponent,
		PaymentSuccessComponent,
		TestimonialComponent,
		UnsubscriptionComponent,
		ClientsComponent,
		PrivacyPolicyComponent,
		TermsAndConditionsComponent,
		MiniaarComponent,
		DetailMasterComponent,
		PageNotFoundComponent,
		CasestudyComponent,
		DemoCaseStudyComponent,
		CrystalcargoComponent,
	],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		AppRoutingModule,
		HttpClientModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		CarouselModule,
		ToastrModule.forRoot(),
		NgbModule,
		NgbAccordionModule,
		NgbAlertModule,
		NgxIntlTelInputModule,
		BsDropdownModule.forRoot(),
	  LucideAngularModule.pick({ ChevronRight ,Check  }),
	],
	providers: [NgbActiveModal],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
